export const GET_USER_STATS = "GET_USER_STATS";
export const SET_USER_STATS = "SET_USER_STATS";
export const GET_TFA_STATS = "GET_TFA_STATS";
export const SET_TFA_STATS = "SET_TFA_STATS";
export const GET_MESSAGEBIRD_BALANCE = "GET_MESSAGE_BIRD_BALANCE";
export const SET_MESSAGEBIRD_BALANCE = "SET_MESSAGEBIRD_BALANCE";
export const GET_MESSAGEBIRD_DETAILS = "GET_MESSAGEBIRD_DETAILS";
export const SET_MESSAGEBIRD_DETAILS = "SET_MESSAGEBIRD_DETAILS";
export const GET_WALLET_STATS = "GET_WALLET_STATS_API";
export const SET_WALLET_STATS = "SET_WALLET_STATS_API";